/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import React, { Component } from 'react';
import { withOktaAuth, useOktaAuth } from '@okta/okta-react';
import Button from "@material-ui/core/Button";
import Body from './components/layout/Body'


export default withOktaAuth(class Home extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  async login() {
    await this.props.oktaAuth.signInWithRedirect();
  }

  async logout() {
    await this.props.oktaAuth.signOut();
  }

  render() {
    let body = null;
    if (this.props.authState?.isAuthenticated) {
      body = (
        <div className="Buttons">
          {Apps(this.props.authState)}
        </div>
      );
    } else {
      body = (
        <div className="Buttons">          
          <Button
            variant="outlined"
            color="primary"
            className='common-button'
            onClick={this.login}>
            Login
          </Button>
        </div>
      );
    }

    return (
      <div className="App">
        <header className="App-header">
          {body}
        </header>
      </div>
    );
  }
});


function Apps(oktaService) {
  return (
      <div className="App" >
          <Body oktaAuth={oktaService} />
      </div>
  );
}